import { ModelBase } from 'store/model-base';

export class E911SaveAddress extends ModelBase {
    public static storeName: string = 'e911SaveAddress';

    public requestId: string;
    public mdn: string;
    public address: E911AddressDetails;
}
